import { render, staticRenderFns } from "./chuzhi.vue?vue&type=template&id=0b69b390"
import script from "./chuzhi.vue?vue&type=script&lang=js"
export * from "./chuzhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports